// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './plugins/pinia';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import vuetify from "@/plugins/vuetify";
import { loadFonts } from './plugins/webfontloader'

loadFonts()

// Import Tailwind CSS
import './assets/tailwind.css';

createApp(App)
    .use(router)
    .use(vuetify)
    .use(pinia)
    .use(Toast)
    .mount('#app');
